import * as bridge from './core/index';
var apis = [
    require('./api/addChannel'),
    require('./api/adInfo'),
    require('./api/appInfo'),
    require('./api/close'),
    require('./api/confirmUploadPhoto'),
    require('./api/gallery'),
    require('./api/getSubScribedChannelList'),
    require('./api/isAppInstalled'),
    require('./api/login'),
    require('./api/openCommodity'),
    require('./api/pay'),
    require('./api/sendLog'),
    require('./api/share'),
    require('./api/shareResult'),
    require('./api/showSharePanel'),
    require('./api/takePhoto'),
    require('./api/visible'),
    require('./api/sendLogV3'),
    require('./api/tracker'),
    require('./api/fetch'),
    require('./api/openAweme'),
    require('./api/openSchema'),
    require('./api/setupStayDialog'),
    require('./api/takePicture'),
    require('./api/uploadFile'),
    require('./api/H5_uploadFile'),
    require('./api/launchWXMiniPro'),
    require('./api/webControl'),
    require('./api/closeAndOpen'),
    require('./api/userInfo'),
    require('./api/islogin'),
    require('./api/loginStatus'),
    require('./api/openHotsoon'),
    require('./api/app.liveFloatingWindow'),
    require('./api/app.commerceDetailBarHeight')
];
apis.forEach(bridge.register);
export default bridge;
